import { useQuery } from "@tanstack/react-query";
import artistsBriefsClient from "../../../api/artists-briefs";

const useArtistsBriefSubmissionsQuery = () => {
  return useQuery({
    queryKey: ["artists-brief-submissions"],
    queryFn: () => artistsBriefsClient.getSubmissions(),
  });
};

export default useArtistsBriefSubmissionsQuery;
